import { Injectable } from '@angular/core';
import { MetadataResource } from './metadata.resource';

@Injectable({
  providedIn: 'root',
})
export class EmploymentTypeService extends MetadataResource {
  constructor() {
    super('employment-type');
  }
}
